// Just For Teens — Theme JS

document.addEventListener('DOMContentLoaded', function() {

  // Cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = cart.item_count;
        if (badge) badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
  }
  updateCartCount();

  // Add to cart
  const addForm = document.querySelector('.product-form');
  if (addForm) {
    addForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = addForm.querySelector('.product-page__add');
      const originalText = btn.textContent;
      btn.textContent = 'Adicionado ✓';
      btn.style.background = '#3B6D11';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addForm.querySelector('[name="id"]').value, quantity: 1 })
      })
      .then(() => {
        updateCartCount();
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
        }, 2000);
      });
    });
  }

  // Variant selection
  document.querySelectorAll('.product-page__variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const group = this.closest('.product-page__variant-btns');
      group.querySelectorAll('.product-page__variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput && this.dataset.variantId) {
        variantInput.value = this.dataset.variantId;
      }
    });
  });

  // Smooth image hover on product cards
  document.querySelectorAll('.product-card').forEach(card => {
    const imgs = card.querySelectorAll('.product-card__img img');
    if (imgs.length > 1) {
      card.addEventListener('mouseenter', () => { imgs[0].style.opacity = '0'; imgs[1].style.opacity = '1'; });
      card.addEventListener('mouseleave', () => { imgs[0].style.opacity = '1'; imgs[1].style.opacity = '0'; });
    }
  });

});
